import { render, staticRenderFns } from "./blog-card.vue?vue&type=template&id=7ca39b1c&scoped=true"
import script from "./blog-card.vue?vue&type=script&lang=js"
export * from "./blog-card.vue?vue&type=script&lang=js"
import style0 from "./blog-card.vue?vue&type=style&index=0&id=7ca39b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca39b1c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default})
